const defaultLevels: Record<App.BusinessTraveller.BusinessBudgetPlaceType, number> = {
  global: 1,
  city: 2,
  country: 3,
  region: 4,
}

function sortBudgetByPlaceType(
  budgets: Array<App.BusinessTraveller.BusinessBudget>,
  levels: Record<App.BusinessTraveller.BusinessBudgetPlaceType, number> = defaultLevels,
) {
  return budgets.sort((budget1, budget2) => {
    let placeTypeComparison = 0
    if (budget1.placeType && budget2.placeType) {
      placeTypeComparison = levels[budget1.placeType] - levels[budget2.placeType]
    }
    // if they have the same place, sort by alphabetical
    if (placeTypeComparison === 0) {
      return (budget1.name ?? '').localeCompare(budget2.name ?? '')
    }

    return placeTypeComparison
  })
}

export default sortBudgetByPlaceType
